import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { tick } from '@angular/core/testing';
import { AppConfigService } from './app-config.service';
import { RebarAuthService } from '../rebarauth/rebar.auth.service';

export interface ReviewDetailsFilters {
  ReviewID: number | null;
  PropsedYearId: string | null;
  Quarter: string | null;
  ProposedMonth: string | null;
  ClientName: string | null;
  DeliveryCountry: string | null;
  LocationToBeReviewed: string | null;
  TeamMembers: string | null;
  Region: string | null;
  ReviewTypeID: string | null;
  ReviewStatus: string | null;
  OverallReportRating: string | null;
}

export interface IssueDetailsFilters {
  ReviewID: number | null;
  PropsedYearId: string | null;
  Quarter: string | null;
  ProposedMonth: string | null;
  ClientName: string | null;
  DeliveryCountry: string | null;
  LocationToBeReviewed: string | null;
  TeamMembers: string | null;
  Region: string | null;
  ReviewTypeID: string | null;
  IssueID: number | null;
  IssueStatus: string | null;
  IssueRatings: string | null;
  IssueCategory: string | null;
}

export interface ActionPlanFilters {
  ReviewID: number | null;
  PropsedYearId: string | null;
  Quarter: string | null;
  ProposedMonth: string | null;
  ClientName: string | null;
  DeliveryCountry: string | null;
  LocationToBeReviewed: string | null;
  TeamMembers: string | null;
  Region: string | null;
  ReviewTypeID: string | null;
  IssueID: number | null;
  ActionPlanID: number | null;
  ActionPlanStatus: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class ReviewerService {
  private readonly _actionPlanRefresh$ = new Subject<void>();
  readonly actionPlanRefresh$ = this._actionPlanRefresh$.asObservable();
  notifyActionPlanSaved(): void { this._actionPlanRefresh$.next(); }

  private get baseUrl(): string {
    return this.appConfigService.config['ReviewFunctionUrl'] as string || '';
  }

  private get peoplebaseUrl(): string {
    return this.appConfigService.config['PeoplePickerAddress'] as string || '';
  }

  private get Notificationurl(): string {
    return this.appConfigService.config['NotificationFunctionUrl'] as string || '';
  }
  projectManagementUrl: any;

  constructor(private http: HttpClient, public authService: RebarAuthService, private appConfigService: AppConfigService) {
    this.projectManagementUrl = this.baseUrl;
  }

  scorablechart(inputData: any): Observable<any> {
    let params = new HttpParams();
    params = params.append('jobid', inputData.jobid);
    params = params.append('handler', 'getScorableChart');
    return this.http.get(this.baseUrl, { params: params });
  }
  GetTokenforPeople(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'GetToken');
    const token = this.http.get(this.baseUrl, { params: params });
    return token;
  }

  getRoleDetail(inputData: any): Observable<any> {
    const postData = {
      params: {
        category: 'getRoleDetails',
        jwt_token: localStorage.getItem('jwt_token')
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  getRoleDetailAdhoc(inputData: any): Observable<any> {
    const postData = {
      params: {
        category: 'getRoleDetailsAdhoc',
        jwt_token: localStorage.getItem('jwt_token'),
        CycleId: parseInt(localStorage.getItem('AdhocMapid'))
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  getRoleDetailAdhocSurvey(inputData: any): Observable<any> {
    const postData = {
      params: {
        category: 'getRoleDetailsAdhocSurvey',
        jwt_token: localStorage.getItem('jwt_token')
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  getActiveAdhocSurvey(): Observable<any> {
    const postData = {
      params: {
        category: 'getActiveAdhocSurvey'
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  Userloginfo(inputData: any ): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'Userloginfo',
        UserName: inputData.UserName,
        jwt_token: localStorage.getItem('jwt_token'),
        Login_time:inputData.Login_time,
        logout_time:inputData.logout_time,
        type: inputData.type
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  fetchAdminactions(inputData: any, loginID: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params:{
      category: 'getAdminactionItems',
      CycleName: inputData.CycleName.toString(),
      ActionType: 'Search',
      LoggedEID: loginID.ID,
      BusinessId: inputData.BusinessId,
      ProjectId: inputData.ProjectId,
      ActionStatus: inputData.ActionStatus.toString(),
      AdminStatus: inputData.AdminActionStatus.toString()
    }}
    return this.http.post(this.baseUrl, postData);
  }

  fetchAdminactionsReport(inputData: any, loginID: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params:{
      category: 'getAdminactionItemsReport',
      CycleName: inputData.CycleName.toString(),
      ActionType: 'Search',
      LoggedEID: loginID.ID,
      BusinessId: inputData.BusinessId,
      ProjectId: inputData.ProjectId,
      ActionStatus: inputData.ActionStatus.toString(),
      AdminStatus: inputData.AdminActionStatus.toString()
    }}
    return this.http.post(this.baseUrl, postData);
  }

  fetchAdminactionsReportAdhoc(inputData: any, loginID: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params:{
      category: 'getAdminactionItemsReportAdhoc',
      CycleName:localStorage.getItem('AdhocMapid'),
      ActionType: 'Search',
      LoggedEID: loginID.ID,
      BusinessId: inputData.BusinessId,
      ProjectId: inputData.ProjectId,
      ActionStatus: inputData.ActionStatus.toString(),
      AdminStatus: inputData.AdminActionStatus.toString()
    }}
    return this.http.post(this.baseUrl, postData);
  }

  fetchOpenactions(inputData: any, loginID: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params:{
        category: 'getOpenactionItems',
        ActionType: 'Search',
        LoggedEID: loginID.ID,
        BusinessId: inputData.BusinessId,
        ProjectId: inputData.ProjectId,
        timeZoneOffset: inputData.timeZoneOffset
      }
    }
    return this.http.post(this.baseUrl, postData);
  }

  getStatus(networkParams): Observable<any> {
    let params = new HttpParams();
    for (const prop in networkParams) {
      params = params.append(prop, networkParams[prop]);
    }
    return this.http.get(this.baseUrl, { params: params });
  }

  GetDefaulterReport(inputData: any): Observable<any> {
    let params = new HttpParams();
   const postData = {
      params : {
      category:'getDefaulterReport',
      EnterpriseID: inputData.EnterpriseId,
      Role : inputData.Role.toString(),
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  GetDefaulterReportEVT( inputData: any): Observable<any> {
    let params = new HttpParams();
   const postData = {
      params: {
      category:'getDefaulterReportEVT',
      EnterpriseID: inputData.EnterpriseId,
      Role: inputData.Role.toString(),
      CycleId: localStorage.getItem('AdhocMapid')
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  GetDefaulterReportAdhoc2(inputData: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'GetDefaulterListReportAdhoc2',
        EnterpriseID: inputData.EnterpriseId,
        Role: inputData.Role.toString(),
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  GetBusinessFunctions(inputData: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getBusinessFunctions',
        Role: inputData.Role.toString(),
        EnterpriseID: inputData.EnterpriseId
      }
    }
    return this.http.post(this.baseUrl, postData);
  }

  GetManageReviewAccess(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'getManageReviewAccess');
    return this.http.get(this.baseUrl, { params: params });
  }

  getManageReviewCountry(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'getManageReviewCountry');
    params = params.append('EnterpriseID', localStorage.getItem('jwt_token'));
    return this.http.get(this.baseUrl, { params: params });
  }

  getCareerLevelDetails(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'getCareerLevelDetails');
    return this.http.get(this.baseUrl, { params: params });
  }

  getManageReviewEnterpriseId(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'getManageReviewEnterpriseId');
    return this.http.get(this.baseUrl, { params: params });
  }

  getPOCCareerLevelReport(inputData: any): Observable<any> {
    let params = new HttpParams();
    params = params.append('AssesmeentCycleId', inputData.AssesmeentCycleId);
    params = params.append('handler', 'getPOCCareerLevelReport');
    params = params.append('EnterpriseID', localStorage.getItem('jwt_token'));
    return this.http.get(this.baseUrl, { params: params });
  }

  saveRow(inputData: any) {
    return this.http.post(this.baseUrl, inputData);
  }

  saveMultipleRow(modifiedData: any, loggedID: any, timeZoneOffset: number) {
    const jsonStringData = JSON.stringify(modifiedData);
    const postData = {
      params: {
        category: 'AddReviewerMultipleRow',
        formdata: modifiedData,
        loggedInId: loggedID,
        timeZoneOffset: timeZoneOffset,
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  getCareerLevel(networkParams): Observable<any> {
    let params = new HttpParams();
    for (const prop in networkParams) {
      params = params.append(prop, networkParams[prop]);
    }
    return this.http.get(this.baseUrl, { params: params });
  }

  getBaseDataReport(inputData: any): Observable<any> {

    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getBaseDataReport',
        CycleId: inputData.cycleId,
        BusinessFunctionId: inputData.businessFunctionId,
        ServiceGroup: inputData.serviceGroup,
        EnterpriseID: inputData.EnterpriseId,
        Role: inputData.Role.toString()
      }
    }

    return this.http.post(this.baseUrl, postData);
  }

  getBaseDataReportAdhoc2(inputData: any): Observable<any> {

    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getBaseDataReportAdhoc2',
        CycleId: inputData.cycleId,
        BusinessFunctionId: inputData.businessFunctionId,
        ServiceGroup: inputData.serviceGroup,
        EnterpriseID: inputData.EnterpriseId,
        Role: inputData.Role.toString()
      }
    }

    return this.http.post(this.baseUrl, postData);
  }

  getBaseDataReportEVT(inputData: any): Observable<any> {

    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getBaseDataReportEVT',
        CycleId: inputData.cycleId,
        BusinessFunctionId: inputData.businessFunctionId,
        ServiceGroup: inputData.serviceGroup,
        EnterpriseID: inputData.EnterpriseId,
        Role: inputData.Role.toString(),
        CategoryMappingId: inputData.CategoryMappingId
      }
    }

    return this.http.post(this.baseUrl, postData);
  }

  getBusinessQuestions(inputData: any): Observable<any> {
    const postData = {
      params: {
        category: 'getBusinessQuestions',
        BusinessFunctionId: inputData.businessFunctionId,
        ServiceGroup: inputData.serviceGroup,
        EnterpriseID: localStorage.getItem('jwt_token')
      }
    }

    return this.http.post(this.baseUrl, postData);
  }


  getBusinessQuestionsAdhoc2(inputData: any): Observable<any> {
    const postData = {
      params: {
        category: 'getBusinessQuestionsAdhoc2',
        BusinessFunctionId: inputData.businessFunctionId,
        ServiceGroup: inputData.serviceGroup,
        EnterpriseID: localStorage.getItem('jwt_token')
      }
    }

    return this.http.post(this.baseUrl, postData);
  }

  getBusinessServiceGroup(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'getBusinessServiceGroup');
    return this.http.get(this.baseUrl, { params: params });
  }

  getReviewMailsReport(inputData: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getReviewMailsReport',
        RepBusinessFunctionId: inputData.RepBusinessFunctionId,
        ServiceGroupId: inputData.ServiceGroupId,
        AssesmeentCycleId: inputData.AssesmeentCycleId
      }
    }
    return this.http.post(this.baseUrl, postData);
  }

  getadhocAdminReviewMailsSendservice(inputData: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getadhocAdminReviewMailsSend',
        MailDate: inputData.MailDate,
        RepBusinessFunctionId: inputData.businessFunctionId,
        Flag: inputData.Flag,
        LoggedInId: inputData.LoggedInId
      }
    }
    return this.http.post(this.baseUrl, postData).pipe(
      timeout(300000),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          console.error('Request timed out');
        } else {
          console.error('Request error:', error.message);
        }
        return throwError(() => new Error('An error occurred'));
      })
    );
  }

  adhocAdminSendmailReviewerservice(inputData: any): Observable<any> {
    let params = new HttpParams();
    params = params.append('MailDate', inputData.MailDate);
    params = params.append(
      'RepBusinessFunctionId',
      inputData.businessFunctionId
    );
    params = params.append('Flag', inputData.Flag);
    params = params.append('LoggedInId', inputData.LoggedInId);
    params = params.append('handler', 'adhocAdminSendmailReviewer');
    return this.http.get(this.baseUrl, { params: params }).pipe(
      timeout(300000),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          console.error('Request timed out');
        } else {
          console.error('Request error:', error.message);
        }
        return throwError(() => new Error('An error occurred'));
      })
    );


  }

  SaveAdminActionitems(
    modifiedData: any,
    CycleName: any,
    LoggedInUserDet: any,
    timeZoneOffset = 0
  ) {
    const jsonStringData = JSON.stringify(modifiedData);
    const postData = {
      params: {
        category: 'SaveAdminActionitems',
        formdata: modifiedData,
        CycleName: CycleName,
        ActionType: 'Update',
        LoggedEID: LoggedInUserDet,
        timeZoneOffset: timeZoneOffset,
      },
    };
    return this.http.post(this.projectManagementUrl, postData);
  }

  SaveOpenActionitems(
    modifiedData: any,
    LoggedInUserDet: any,
    timeZoneOffset: number
  ) {
    const jsonStringData = JSON.stringify(modifiedData);
    const postData = {
      params: {
        category: 'SaveOpenActionitems',
        formdata: modifiedData,
        ActionType: 'Update',
        LoggedEID: LoggedInUserDet,
        timeZoneOffset: timeZoneOffset,
      },
    };
    return this.http.post(this.projectManagementUrl, postData);
  }

  getNetworkData(networkParams): Observable<any> {
    let params = new HttpParams();
    for (const prop in networkParams) {
      params = params.append(prop, networkParams[prop]);
    }
    return this.http.get(this.baseUrl, { params: params });
  }
  postToServer(generalInputs): Observable<any> {
    return this.http.post(this.baseUrl, generalInputs);
  }

  getBusinessCategoryForBaseDataReport(inputData: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getBusinessCategoryForBaseData',
        BusinessFunctionId: inputData.businessFunctionId,
        ServiceGroupId: inputData.ServiceGroupId,
      }
    }
    return this.http.post(this.baseUrl, postData);
  }

  getAdhocSurveylink(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'getAdhocSurveylink');
    params = params.append('EnterpriseID', localStorage.getItem('jwt_token'));
    return this.http.get(this.baseUrl, { params: params });
  }
  getJWTsecretkey(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'GetJWTsecretKey');
    let result = this.http.get<any[]>(this.baseUrl, { params: params })
    return result;
  }

  generateToken(EnterpriseID): string {
    const userDetails = {
      EnterpriseID: EnterpriseID
    };
    const payload = btoa(JSON.stringify(userDetails));
    const secretKey = localStorage.getItem('Tokenkey');
    const header = btoa(JSON.stringify({ alg: secretKey, typ: 'JWT' }));

    const token = `${header}.${payload}.`;

    return token;
  }

  LastMail(inputData: any, mailtype: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'LastMailDate',
        RepBusinessFunctionId: inputData,
        mailtypeid: mailtype
      }
    }
    return this.http.post(this.projectManagementUrl, postData);
  }


  getProjectManagementEclipse(inputData: any) {
    const postData = {
      params: {
        category: 'getProjectManagementEclipse',
        CycleId: inputData.CycleId,
      },
    };
    return this.http.post(this.projectManagementUrl, postData);
  }

  saveProjectDataEclipse(modifiedData: any) {
    const jsonStringData = JSON.stringify(modifiedData);
    const postData = {
      params: {
        category: 'saveProjectDataEclipse',
        formdata: modifiedData,
      },
    };
    return this.http.post(this.projectManagementUrl, postData);
  }

  automationUpdate(inputData: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'InternalExceptionHandling_Adhoc',
        data: inputData
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  automationUpdate_AddProjects(inputData: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'InternalExceptionHandling_AdhocAddProjects',
        data: inputData
      }
    };
    return this.http.post(this.baseUrl, postData);
  }


  getAdhocSurveyName(Surveyid): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getAdhocSurveyName',
        Surveyid: Surveyid
      }
    }
    return this.http.post(this.baseUrl, postData);
  }

  getRepletterAdhocScreenData(Surveyid): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getRepletterAdhocScreenData',
        Surveyid: Surveyid
      }
    }
    return this.http.post(this.baseUrl, postData);
  }
  GetBusinessFunctionsAdhoc(inputData: any): Observable<any> {
    let params = new HttpParams();
    const postData = {
      params: {
        category: 'getBusinessFunctionsAdhoc',
        Role: inputData.Role.toString(),
        EnterpriseID: inputData.EnterpriseId,
        CycleId: inputData.CycleId,
      }
    }
    return this.http.post(this.baseUrl, postData);
  }

  GetRequestedAdhocSurveylist(): Observable<any> {
    const postData = {
      params: {
        category: 'GetRequestedAdhocSurveylist',
        Userid: localStorage.getItem('jwt_token'),
      },
    };
    return this.http.post(this.baseUrl, postData);
  }
  GetRequestedAdhocSurveyApprovalList(): Observable<any> {
    const postData = {
      params: {
        category: 'GetRequestedAdhocSurveyApprovalList',
        Userid: localStorage.getItem('jwt_token'),
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  GetAdhocGeneralInfo(): Observable<any> {
    const postData = {
      params: {
        category: 'GetAdhocGeneralInfo',
        Userid: localStorage.getItem('jwt_token'),

      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  GetAdhocScope(): Observable<any> {
    const postData = {
      params: {
        category: 'GetAdhocScope',
        Userid: localStorage.getItem('jwt_token'),

      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  GetAdhocQuestion(): Observable<any> {
    const postData = {
      params: {
        category: 'GetAdhocQuestion',
        Userid: localStorage.getItem('jwt_token'),

      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  GetAdhocScopeQuestionsData(): Observable<any> {
    const postData = {
      params: {
        category: 'GetAdhocScopeQuestionsData',
        Userid: localStorage.getItem('jwt_token')
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  SendApproval(inputData: any): Observable<any> {
    const postData = {
      params: {
        category: 'AdhocSurevyMailssent',
        SurveyName: inputData.SurveyName,
        sendto: inputData.Createduser,
        ReviewerID: localStorage.getItem('jwt_token')
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  SendReminderMail(): Observable<any> {
    const postData = {
      params: {
        category: 'SendReminderMail',
        userid: localStorage.getItem('jwt_token')
      }
    };
    return this.http.post(this.baseUrl, postData);
  }


  GetAdhocSurveyDetails(SurveyName: string): Observable<any> {
    const postData = {
      params: {
        category: 'GetAdhocSurveyDetails',
        SurveyName: SurveyName
      },
    };
    return this.http.post(this.baseUrl, postData);
  }


  GetAdhocProjectinfo(id: string): Observable<any> {
    let ID: any;
    if (id == '1') { ID = localStorage.getItem('jwt_token') }
    else { ID = ID }
    const postData = {
      params: {
        category: 'GetAdhocProjectinfo',
        Userid: ID,
        flag: id

      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  GetAdhocuseraccessinfo(id: string): Observable<any> {
    let ID: any;
    if (id == '1') { ID = localStorage.getItem('jwt_token') }
    else { ID = ID }
    const postData = {
      params: {
        category: 'GetAdhocuseraccessinfo',
        Userid: ID,
        flag: id

      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  AdhocSurveyinsert(inputData: any): Observable<any> {
    const postData = {
      params: {
        category: 'AdhocSurveyinsert',
        Userid: localStorage.getItem('jwt_token'),
        surveyMasterData: inputData.surveyMasterData,
        scopeData: inputData.scopeData,
        questionData: inputData.questionData,
        QuestionFlowData: inputData.QuestionFlowData,
        Actionid: 0
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  AdhocSurveyDelete(): Observable<any> {
    const postData = {
      params: {
        category: 'AdhocSurveyDelete',
        Userid: localStorage.getItem('jwt_token'),
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  AdhocSurveyDataSave(inputData: any): Observable<any> {
    const postData = {
      params: {
        category: 'AdhocSurveyDataSave',
        Userid: localStorage.getItem('jwt_token'),
        projectData: inputData.projectData,
        accessManagementData: inputData.accessManagementData,
        rationalecomments: inputData.rationalecomments,
        surveyMasterData: inputData.surveyMasterData,
        Comments: inputData.feedbackcomments,
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  FeeadbackMail(inputData: any, feedbackText: string): Observable<any> {
    const postData = {
      params: {
        category: 'FeeadbackMail',
        SurveyName: inputData.SurveyName,
        sendto: inputData.Createduser,
        feedbackText: feedbackText,
        RID: localStorage.getItem('jwt_token')
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  ApprovalAccess(): Observable<any> {
    const postData = {
      params: {
        category: 'ApprovalAccess',
        Userid: localStorage.getItem('jwt_token'),
      },
    };
    return this.http.post(this.baseUrl, postData);
  }


  getApplicationRoleDetails(enterpriseId: string): Observable<any> {
    const postData = {
      params: {
        category: 'GetRoleDetails',
        EnterpriseID: enterpriseId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }


  //AST API calls

  TestDBconnection(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'TestDBconnection');
    return this.http.get(this.baseUrl, { params: params });
  }
  GetWelcomeMessage(): Observable<any> {
    let params = new HttpParams();
    params = params.append('handler', 'GetWelcomeMessage');
    return this.http.get(this.Notificationurl, { params: params });
  }

  getReviewTypes(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetReviewTypeName`);
  }

  getPurposedYear(): Observable<any> {
     return this.http.get<any>(`${this.baseUrl}?handler=GetProposedYear`);
  }

  getTypeofProject(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetTypeofProject`);
  }
    getAllCountries(): Observable<any> {
     return this.http.get<any>(`${this.baseUrl}?handler=GetAllCountries`);
  }
  getAllCities(countryMasterID: number): Observable<any> {
    const postData = {
      params: {
        category: 'GetCitiesByCountry',
        CountryMasterID: countryMasterID
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  getProjectDetails(): Observable<any> {
    const postData = {
      params: {
        category: 'GetRepletterProjectList_AST',
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  uploadMultipleFiles(files: { fileName: string; fileContent: string }[]): Observable<any> {
    const postData = {
      params: {
        category: 'UploadMultipleFiles',
        files
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  // Previous API retained for reference:
  // getReviewDetails(): Observable<any> {
  //   return this.http.get<any>(`${this.baseUrl}?handler=GetReviewDetails`);
  // }

  getReviewDetails(filters: Partial<ReviewDetailsFilters> = {}): Observable<any> {
    const params: ReviewDetailsFilters & { category: string } = {
      category: 'GetScheduleReviewDetailsDynamic_Test',
      ReviewID: null,
      PropsedYearId: null,
      Quarter: null,
      ProposedMonth: null,
      ClientName: null,
      DeliveryCountry: null,
      LocationToBeReviewed: null,
      TeamMembers: null,
      Region: null,
      ReviewTypeID: null,
      ReviewStatus: null,
      OverallReportRating: null,
      ...filters,
    };

    return this.http.post<any>(this.baseUrl, { params });
  }

   getIssueDetails(filters: Partial<IssueDetailsFilters> = {}): Observable<any> {
    const params: IssueDetailsFilters & { category: string } = {
      category: 'GetIssue_EAV',
      ReviewID: null,
      IssueID: null,
      PropsedYearId: null,
      Quarter: null,
      ProposedMonth: null,
      ClientName: null,
      DeliveryCountry: null,
      LocationToBeReviewed: null,
      TeamMembers: null,
      Region: null,
      ReviewTypeID: null,
      IssueStatus: null,
      IssueRatings: null,
      IssueCategory: null,
      ...filters,
    };

    return this.http.post<any>(this.baseUrl, { params }).pipe(
      map((response: any) => {
        if (Array.isArray(response) && response.length > 0) {
          const keys = Object.keys(response[0]);
          if (keys.length === 1) {
            const raw = (response as any[]).map(row => row[keys[0]] ?? '').join('');
            if (raw) {
              try { return JSON.parse(raw); } catch (e) { return []; }
            }
          }
          return response;
        }
        return Array.isArray(response) ? response : [];
      })
    );
  }

  getActionPlanDetails(filters: Partial<ActionPlanFilters> = {}): Observable<any> {
    const params: ActionPlanFilters & { category: string } = {
      category: 'GetActionPlans_EAV_Test',
      ReviewID: null,
      IssueID: null,
      PropsedYearId: null,
      Quarter: null,
      ProposedMonth: null,
      ClientName: null,
      DeliveryCountry: null,
      LocationToBeReviewed: null,
      TeamMembers: null,
      Region: null,
      ReviewTypeID: null,
      ActionPlanStatus: null,
      ActionPlanID: null,
      ...filters,
    };

    return this.http.post<any>(this.baseUrl, { params }).pipe(
      map((response: any) => {
        if (Array.isArray(response) && response.length > 0) {
          const keys = Object.keys(response[0]);
          if (keys.length === 1) {
            const raw = (response as any[]).map(row => row[keys[0]] ?? '').join('');
            if (raw) {
              try { return JSON.parse(raw); } catch (e) { return []; }
            }
          }
          return response;
        }
        return Array.isArray(response) ? response : [];
      })
    );
  }

  getServiceLines(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetServiceLines`);
  }

  getLocationNamesByReviewId(reviewId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetLocationNamesByReviewID&ReviewID=${reviewId}`);
  }

  getRepletterQuestions(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetRepletterQuestions`);
  }

  getRiskCategories(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetRiskCategories`);
  }

  getInternalDependencies(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetInternalDependency`);
  }

  CreateIssue(issueData: any): Observable<any> {
    const postData = {
      params: {
        category: 'CreateIssue',
        ActionType: 'Create',
        ...issueData
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  CreateIssueWithActionPlan(issueData: any, linkedActionplan: any[]): Observable<any> {
    const postData = {
      params: {
        category: 'CreateIssueWithActionPlan',
        issueData,
        linkedActionplan,
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  UpsertIssueWithActionPlanEAV(params: any): Observable<any> {
    return this.http.post(this.baseUrl, { params }).pipe(
      map((response: any) => {
        if (Array.isArray(response) && response.length > 0) {
          const keys = Object.keys(response[0]);
          if (keys.length === 1) {
            const raw = (response as any[]).map(row => row[keys[0]] ?? '').join('');
            if (raw) { try { return JSON.parse(raw); } catch (e) { return response; } }
          }
        }
        return response;
      })
    );
  }

  getIssueEAV(reviewId: number | null, issueId: number | null = null): Observable<any> {
    return this.http.post(this.baseUrl, {
      params: { category: 'GetIssue_EAV', ReviewID: reviewId, IssueID: issueId }
    }).pipe(
      map((response: any) => {
        if (Array.isArray(response) && response.length > 0) {
          const keys = Object.keys(response[0]);
          if (keys.length === 1) {
            const raw = (response as any[]).map(row => row[keys[0]] ?? '').join('');
            if (raw) {
              try { return JSON.parse(raw); } catch (e) { return []; }
            }
          }
          return response;
        }
        return Array.isArray(response) ? response : [];
      })
    );
  }

  getActionPlansEAV(reviewId: number | null, actionPlanId: number | null = null, issueId: number | null = null): Observable<any> {
    return this.http.post(this.baseUrl, {
      params: { category: 'GetActionPlans_EAV_Test', ReviewID: reviewId, ActionPlanID: actionPlanId, IssueID: issueId }
    }).pipe(
      map((response: any) => {
        if (Array.isArray(response) && response.length > 0) {
          const keys = Object.keys(response[0]);
          if (keys.length === 1) {
            const raw = (response as any[]).map(row => row[keys[0]] ?? '').join('');
            if (raw) {
              try { return JSON.parse(raw); } catch (e) { return []; }
            }
          }
          return response;
        }
        return Array.isArray(response) ? response : [];
      })
    );
  }

  getUsersInformation(roleName: string): Observable<any> {
    const postData = {
      params: {
        category: 'GetSupervisorInformation',
      },
    };
    return this.http.post(this.baseUrl, postData);
  }

  getIssue(reviewId: number | null, issueId: number | null = null): Observable<any> {
    const postData = {
      params: {
        category: 'GetIssue',
        ReviewID: reviewId,
        IssueID: issueId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  updateIssueStatus(params: {
    IssueID: number;
    ReviewID: number;
    IssueStatus: string;
    LoggedUserID: string;
    ReasonForReject: string | null;
  }): Observable<any> {
    const postData = {
      params: {
        category: 'UpdateIssueStatus',
        ...params
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  getActionPlans(reviewId?: number, actionPlanId?: string): Observable<any> {
    if (reviewId != null) {
      let params = new HttpParams();
      params = params.append('handler', 'GetActionPlans');
      params = params.append('ReviewID', reviewId.toString());
      if (actionPlanId) {
        params = params.append('ActionPlanID', actionPlanId);
      }
      return this.http.get<any>(this.baseUrl, { params }).pipe(
        map((response: any) => {
          if (Array.isArray(response) && response.length > 0) {
            const keys = Object.keys(response[0]);
            if (keys.length === 1) {
              const raw = (response as any[]).map(row => row[keys[0]] ?? '').join('');
              if (raw) {
                try { return JSON.parse(raw); } catch (e) { console.error('GetActionPlans JSON parse error', e); return []; }
              }
            }
            return response;
          }
          return Array.isArray(response) ? response : [];
        })
      );
    }
    return this.http.get<any>(`${this.baseUrl}?handler=GetActionPlans`);
  }

  getLastInsertedIssueByReviewId(reviewId: number | null): Observable<any> {
    const postData = {
      params: {
        category: 'GetLastInsertedIssueByReviewID',
        ReviewID: reviewId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  getLastInsertedActionPlanByReviewId(reviewId: number | null): Observable<any> {
    const postData = {
      params: {
        category: 'GetLastInsertedActionPlanByReviewID',
        ReviewID: reviewId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  getReviewDetailsByID(reviewId: number): Observable<any> {
    const postData = {
      params: {
        category: 'GetReviewDetailsByID',
        ReviewID: reviewId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  getScheduleReviewDetailsDynamic(reviewId: number): Observable<any> {
    const postData = {
      params: {
        category: 'GetScheduleReviewDetailsDynamic',
        ReviewID: reviewId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  // getServiceLines(): Observable<any> {
  //   return this.http.get<any>(`${this.baseUrl}?handler=GetServiceLines`);
  // }

  getReviewGroupByID(reviewId: number): Observable<any> {
    const postData = {
      params: {
        category: 'GetReviewGroupByID',
        ReviewID: reviewId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  createSchedule(payload: any): Observable<any> {
    return this.http.post(this.baseUrl, { params: payload });
  }

  checkScheduleEntryExists(reviewId: number): Observable<any> {
    const postData = {
      params: {
        category: 'IsScheduleEntryExists',
        ReviewID: reviewId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  SaveReviewData(payload: any): Observable<any> {
    const postData = { params: payload };
    return this.http.post(this.baseUrl, postData);
  }

  SaveReviewDynamic(payload: any): Observable<any> {
    return this.http.post(this.baseUrl, { params: payload });
  }

  draftStandardReviewBulkUpload(payload: any): Observable<any> {
    return this.http.post(this.baseUrl, { params: payload });
  }

  bulkUploadIssue(payload: any): Observable<any> {
    return this.http.post(this.baseUrl, { params: payload });
  }

  getKickOffDatebyID(reviewId: number): Observable<any> {
    const postData = {
      params: {
        category: 'GetMilestoneKickOffDateByReviewID',
        ReviewID: reviewId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  /** Upsert the Standard Review form (inserts new locations, updates existing ones). */
  UpdateOrInsertReviewForm(reviews: any, documents: any): Observable<any> {
    const postData = {
      params: {
        category: 'UpdateOrInsertReviewForm',
        reviews: reviews,
        documents: documents
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  updateReviewDynamic(params: object): Observable<any> {
    return this.http.post(this.baseUrl, { params: { category: 'UpdateReviewDynamic', ...params } });
  }

  saveReviewCycleActivity(payload: any): Observable<any> {
    const postData = {
      params: {
        category: 'InsertReviewCycleActivityWithDocument',
        ...payload
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  getReviewActivities(reviewId: number): Observable<any> {
    const postData = {
      params: {
        category: 'GetReviewCycleActivityWithDocument',
        ReviewID: reviewId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  deleteReviewCycleDocument(payload: any) : Observable<any> {
    return this.http.post(this.baseUrl, payload);
  }

  deleteIssueDocument(issueId: number, eid: string): Observable<any> {
    return this.http.post(this.baseUrl, {
      params: { category: 'DeleteIssueDocument', IssueID: issueId, EID: eid }
    });
  }

  deleteReviewDocument(reviewId: number, documentId: number, eid: string): Observable<any> {
    return this.http.post(this.baseUrl, {
      params: { category: 'DeleteReviewDocument', ReviewID: reviewId, DocumentID: documentId, EID: eid }
    });
  }

  downloadIssueDocument(storagePath: string): Observable<Blob> {
    let params = new HttpParams();
    params = params.append('handler', 'DownloadFile');
    params = params.append('fileName', storagePath);
    return this.http.get<any>(this.baseUrl, { params }).pipe(map(res => this.toFileBlob(res)));
  }

  // The DownloadFile API returns JSON with base64 content, not raw bytes; saving it as-is corrupts the file.
  private toFileBlob(res: any): Blob {
    if (!res || res.status !== 200 || !res.fileContent) {
      throw new Error(res?.message || 'File download failed.');
    }
    const binary = atob(res.fileContent);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: res.contentType || 'application/octet-stream' });
  }

  updateActionPlan(payload: any): Observable<any> {
    return this.http.post(this.baseUrl, payload);
  }

  updateActionPlanLink(payload: any): Observable<any> {
    return this.http.post(this.baseUrl, payload);
  }

  deleteActionPlan(reviewId: number, actionPlanId: number, loggedUserId: string): Observable<any> {
    const masterUrl = this.appConfigService.config['MasterFunctionUrl'] as string || '';
    return this.http.post(masterUrl, {
      params: { category: 'ASTActionPlanDelete', ReviewID: reviewId, ActionPlanID: actionPlanId, LoggedUserID: loggedUserId }
    });
  }

  deleteIssue(reviewId: number, issueId: number, loggedUserId: string): Observable<any> {
    const masterUrl = this.appConfigService.config['MasterFunctionUrl'] as string || '';
    return this.http.post(masterUrl, {
      params: { category: 'ASTIssueDelete', IssueID: issueId, ReviewID: reviewId, LoggedUserID: loggedUserId }
    });
  }

  downloadFile(storagePath: string, reviewId?: number | null): Observable<Blob> {
    let params = new HttpParams()
      .append('handler', 'DownloadFile')
      .append('fileName', storagePath);
    if (reviewId != null) {
      params = params.append('ReviewID', String(reviewId));
    }
    return this.http.get<any>(this.baseUrl, { params }).pipe(map(res => this.toFileBlob(res)));
  }

  getReviewByIDDynamic(reviewId: number): Observable<any> {
    return this.http.post(this.baseUrl, {
      params: {
        category: 'GetReviewByIDDynamic',
        ReviewID: reviewId
      }
    });
  }

  deleteReview(reviewId: number, modifiedBy: string): Observable<any> {
    return this.http.post(this.baseUrl, {
      params: {
        category: 'DeleteReviewDetails_EAV',
        ReviewID: reviewId,
        ModifiedBy: modifiedBy
      }
    });
  }
}